// extracted by mini-css-extract-plugin
module.exports = {"container":"_25b2-","separator":"_24Ix0","button":"_32LSg","isMobile":"_3oQfe"};